import { observer } from 'mobx-react-lite'
import { useDropzone } from '@/hooks/dropzone-hook'
import { OCRScopingJobsContent } from '@/features/jobs/scoping/components/OCRScopingJobs'
import { OCRScopingJobSidePanelContainer } from '@/features/jobs/scoping/components/OCRScopingJobSidePanel/OCRScopingJobSidePanelContainer'
import { OCRScopingJobMainPanelContainer } from '@/features/jobs/scoping/components/OCRScopingJobMainPanel/OCRScopingJobMainPanelContainer'
import { type OCRScopingJobsViewModel } from '@/features/jobs/scoping/OCRScopingJobsViewModel'
import { CreateOCRScopeJobsDialogContainer } from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog/CreateOCRScopeJobsDialogContainer'

export interface OCRScopingJobsContentContainerProps {
  vm: OCRScopingJobsViewModel
}

export const OCRScopingJobsContentContainer = observer(
  function OCRScopingJobsContentContainer({
    vm,
  }: OCRScopingJobsContentContainerProps) {
    const createScopeJobsVm = vm.createScopeJobsVm
    const { dropzoneProps } = useDropzone<HTMLDivElement>({
      onFilesDropped: createScopeJobsVm.addFiles,
      onEnter: createScopeJobsVm.setDragging,
      onLeave: createScopeJobsVm.stopDragging,
    })

    return (
      <OCRScopingJobsContent
        dropzoneProps={dropzoneProps}
        dragging={createScopeJobsVm.dragging}
        sidePanelVisible={vm.sidePanelVisible}
        onToggleSidePanel={vm.toggleSidePanel}
        sidePanel={
          <OCRScopingJobSidePanelContainer
            vm={vm.sidePanelVm}
            createScopeJobsVm={createScopeJobsVm}
            mainPanelVm={vm.mainPanelVm}
          />
        }
        mainPanel={<OCRScopingJobMainPanelContainer vm={vm} />}
        createDialog={
          <CreateOCRScopeJobsDialogContainer vm={createScopeJobsVm} />
        }
      />
    )
  },
)
